import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    RupeeIcon,
    CalendarIcon,
    CombineInputGroup,
} from "../Styles/InputStyles";
import { FaRupeeSign, FaRegCalendar } from "react-icons/fa";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "../Common/CustomDatePicker";
import DropZone from "./DropZone";

const SecurityDue = ({
    title,
    tenantId,
    selectedOption,
    setSelectedOption,
    addDuesMutate,
    addDuesLoading,
    // data,
    // isEvicted
}) => {
    const [dueDateOpen, setDueDateOpen] = useState(false);
    const [mediaFiles, setMediaFiles] = useState([]);
    const formik = useFormik({
        initialValues: {
            amount: "",
            dueDate: moment().format("YYYY-MM-DD"),
            description: "",
            // adjustFromRefund: false
        },

        onSubmit: (values) => {
            if (!values.amount) {
                toast.error("Please enter amount");
                return;
            }
            if (values.amount <= 0) {
                toast.error("Amount must be greater than 0");
                return;
            }

            if (values.amount > 1000000) {
                toast.error("Amount cannot be greater than 10,00,000");
                return;
            }
            if (!values.dueDate) {
                toast.error("Please select Due date");
                return;
            }

            const formData = new FormData();

            // Append all fields to FormData
            formData.append("amount", Number(values.amount));
            formData.append("dueDate", moment(values.dueDate).format("YYYY-MM-DD"));
            formData.append("description", values.description || "");
            if (values.rentDuration) {
                formData.append("rentDuration", values.rentDuration);
            }
            formData.append("type", Number(selectedOption));
            formData.append("tenantId", tenantId);
            formData.append("title", title);

            // Handle nullable dates
            if (values.startDate) {
                formData.append("startDate", moment(values.startDate).format("YYYY-MM-DD"));
            } else {
                formData.append("startDate", null); // or null, but FormData converts null to "null"
            }

            if (values.endDate) {
                formData.append("endDate", moment(values.endDate).format("YYYY-MM-DD"));
            } else {
                formData.append("endDate", null);
            }

            if (mediaFiles && mediaFiles.length > 0) {
                mediaFiles.forEach((file) => {
                    formData.append("files", file);
                });
            }

            addDuesMutate(formData);
        },
    });
    const handleFileUpload = (files) => {
        setMediaFiles(files);
    };
    // const showAdjustFromRefund = isEvicted && data?.data?.refundAmount > 0;
    return (
        <Container>
            <form
                className="px-1  flex flex-col gap-4"
                onSubmit={formik.handleSubmit}
            >
                <ScrollableContent className="!max-h-[calc(100vh-200px)]">
                    <Wrapper>
                        {/* Amount */}
                        <InputGroup>
                            <Label htmlFor="amount">Amount *</Label>
                            <FieldWrappers>
                                <RupeeIcon />
                                <input
                                    type="text"
                                    id="amount"
                                    placeholder="Enter Amount"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    {...formik.getFieldProps("amount")}
                                    onKeyDown={(e) => {
                                        if (!/^\d$/.test(e.key) && e.key !== "Backspace") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className="pl-6"
                                />
                            </FieldWrappers>
                        </InputGroup>

                        <InputGroup>
                            <Label htmlFor="dueDate">Due Date *</Label>
                            <FieldWrappers>
                                {/* <CalendarIcon />
                <input
                  type="date"
                  id="dueDate"
                  {...formik.getFieldProps("dueDate")}
                  className="pl-6"
                /> */}
                                <CustomDatePicker
                                    // selected={
                                    //     formik.values.dueDate
                                    //         ? new Date(formik.values.dueDate)
                                    //         : null
                                    // }
                                    selected={formik.values.dueDate ? moment(formik.values.dueDate, "YYYY-MM-DD").toDate() : null}
                                    onChange={(date) => {
                                        formik.setFieldValue(
                                            "dueDate",
                                            moment(date).format("YYYY-MM-DD"),
                                        );
                                        setDueDateOpen(false);
                                    }}
                                    onClickOutside={() => setDueDateOpen(false)}
                                    onSelect={() => setDueDateOpen(false)}
                                    open={dueDateOpen}
                                    onInputClick={() => setDueDateOpen(true)}
                                    dateFormat="yyyy-MM-dd"
                                    className="items-center cursor-pointer"
                                    placeholderText="Select due date"
                                    showIcon
                                    icon={
                                        <FaRegCalendar className="text-gray-400 text-xs mt-0.5" />
                                    }
                                    showPopperArrow={false}
                                    wrapperClassName="w-full"
                                    name="dueDate"
                                    id="dueDate"
                                    autoComplete="off"
                                    onFocus={(e) => e.target.blur()}
                                    popperPlacement="bottom-start"
                                    // popperModifiers={[
                                    //   {
                                    //     name: 'offset',
                                    //     options: {
                                    //       offset: [0, 0],
                                    //     },
                                    //   },
                                    // ]}
                                    portalId="root-portal"
                                    popperClassName="react-datepicker-popper"
                                />
                            </FieldWrappers>
                        </InputGroup>
                        {/* Description */}
                        <InputGroup>
                            <Label htmlFor="description">Description</Label>
                            <FieldWrapper>
                                <Textarea
                                    id="description"
                                    placeholder="Enter Description"
                                    {...formik.getFieldProps("description")}
                                    rows={3}
                                />
                            </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                            <Label>Attachments (Optional)</Label>
                            <FieldWrapper>
                                <DropZone
                                    componentFor="expense"
                                    File={mediaFiles}
                                    setFieldValue={(field, value) => {
                                        handleFileUpload(value);
                                    }}
                                    fields={{
                                        name: "files",
                                        value: mediaFiles,
                                        onChange: handleFileUpload,
                                    }}
                                />
                            </FieldWrapper>
                        </InputGroup>

                        {/* {showAdjustFromRefund && (
                            <CheckboxGroup>
                                <CheckboxWrapper>
                                    <Checkbox
                                        type="checkbox"
                                        id="adjustFromRefund"
                                        checked={formik.values.adjustFromRefund}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <CheckboxLabel htmlFor="adjustFromRefund">
                                        Adjust from Refund Amount (₹{data?.data?.refundAmount})
                                    </CheckboxLabel>
                                </CheckboxWrapper>
                                {formik.values.adjustFromRefund && (
                                    <RefundInfo>
                                        This amount will be adjusted from the refund of ₹
                                        {data?.data?.refundAmount}
                                    </RefundInfo>
                                )}
                            </CheckboxGroup>
                        )} */}
                    </Wrapper>
                </ScrollableContent>

                {/* Action Buttons */}
                <ActionSection>
                    <SideCancelBtn type="button" onClick={() => setSelectedOption(null)}>
                        Back
                    </SideCancelBtn>
                    <SubmitBtn type="submit" disabled={addDuesLoading}>
                        {addDuesLoading ? "Submitting..." : "Submit"}
                    </SubmitBtn>
                </ActionSection>
            </form>
        </Container>
    );
};

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Textarea = tw.textarea`min-h-30 border rounded pl-2 py-2 w-full h-30 resize-y  break-words overflow-hidden`;
const CheckboxGroup = tw.div``;
const CheckboxWrapper = tw.div`flex items-center gap-2`;
const Checkbox = tw.input`w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2`;
const CheckboxLabel = tw.label`text-sm font-medium text-gray-700 cursor-pointer`;
const RefundInfo = tw.p`text-xs text-gray-500 mt-1 ml-6`;
export default SecurityDue;
